import React,{useState,useEffect} from 'react'
import {Box, TextField, FormControl, Tooltip, LinearProgress,
        Select, MenuItem, InputLabel, InputAdornment, IconButton, Input,
        Typography, FormLabel, RadioGroup, Radio, FormControlLabel} from '@material-ui/core' 
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Modal from '../generales/ModalCerrarActualiza';
import moment from 'moment'
import {llamaApiCargaToken,ErrorGeneral,llamadaApiCarga } from '../funciones/ClienteAxios';
import { toast } from 'react-toastify'; 
import Relojes from './Relojes';
const ModalNvoEdit = ({modalAbierto,setModalAbierto ,titulo, auxReg, getDatos, listTipo, listRutas, setListRutas}) => {
    let history = useHistory();    
    const fechaMax = moment(new Date()).subtract(18,'years')      
    const source = axios.CancelToken.source();  
    const Dispvo =localStorage.getItem('Dispvo') ;    
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({
            inicio: new Date(), final: new Date(),
        });
    const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
    const usuId =localStorage.getItem('UsuId') ;                    
    const [espera,setEspera]= useState(false);    
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(false)
    const [aviso, setAviso] = useState(false);
    const[cambioEfectivo,serCambioEfectivo] = useState(false)    
    const[nvoRegistro, setNvoRegistro] = useState([])   
    const[listDistrito, setListDistrito]= useState([]);      
    const[listObjeto, setListObjeto]= useState([]);      
    const[listOtb,setListOtb]= useState([]);  
    const[registro, setRegistro] = useState({Llave:0, Tipo:"", Distrito:"", Alias:"", Descr:"", Objeto:"", OtbId:"" })  
    const{Llave, Tipo, Distrito, Alias, Descr, Objeto, OtbId  }=registro
    
    
    useEffect(()=>{    
       if (auxReg.length !==0) 
        {   //console.log(moment.utc(auxReg.original.FFin).local(true).format("DD/MM/YYYY"));
           
            setRegistro({...registro,Llave:auxReg.Id, Nombre:auxReg.Nom,
                //FNacimien:`${moment.utc(auxReg.FNac).format('YYYY-MM-DD')}T12:00`, 
                Alias:auxReg.original.Alias, Descr:auxReg.original.Descr, 
                Tipo: auxReg.original.TpId,  Objeto:auxReg.original.ObjId, Distrito:auxReg.original.DtId,
                OtbId:auxReg.original.OtbId === 0 || auxReg.original.OtbId ==="0" ?"":auxReg.original.OtbId }) 
            setFechasSeleccionadas({inicio:moment.utc(auxReg.original.FIni).local(true), 
                final:moment.utc(auxReg.original.FFin).local(true) })
        }
        getListDto()
        getListObjeto()
    
        return ()=> {
            source.cancel();
        } 
    },[])

    const getListOTB = (Distrito) => {
        const data = qs.stringify({
            Usuario: usuId, Distrito:Distrito,  ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito/otb";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
                
                setListOtb(auxiliar)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }
              
    const getListDto = () => {
        const data = qs.stringify({
            Usuario: usuId, Estado: process.env.REACT_APP_EDO,  ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
                let listNvo=[]
                auxiliar.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom}`})
                }); 
                setListDistrito(listNvo)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListObjeto = () => {
        const data = qs.stringify({
            Usuario: usuId, ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "lugar/ruta/tipo/objeto";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
                
                setListObjeto(auxiliar)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const onChange = e =>
	{   
        let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$.@#_&-+()/:;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setRegistro({
                ...registro, 
                [e.target.name] : e.target.value//.toUpperCase()  
            })            
        }		
	};             

    const llamadaNvoPerfil = ( ) => {       
        const fechaIni=moment( fechasSeleccionadas.inicio).format('YYYY-MM-DD')
        const fechaFin=moment( fechasSeleccionadas.final).format('YYYY-MM-DD')
        const data = qs.stringify({
            Usuario:usuId,
            Llave:Llave,
            Status:1,
            Tipo:Tipo,            
            Distrito:Distrito,   
            Otb: 0,                     
            FIni:`${fechaIni}T00:00:00`,
            FFin:`${fechaFin}T23:59:59`,            
            Color:"#523ae1",
            Orden:1,
            Lat:0.0,
            Lon:0.0,
            Alias:Alias,
            Descr:Descr,
            Objeto:Objeto,
            idDispositivo: auxDispV,
        });
        const url = "lugar/v3/ruta/new-edit";
        function respuesta(aux) {
            if (aux.length!==0)
            {   setBtnDeshabilitado(true)                                             
                const mensaje=auxReg.length !==0 ?"Se edito correctamente":"Se registro correctamente"
                setTipoAdvertencia("success")      
                setMensaje(mensaje);                
                setAviso(false);
                toast.success(mensaje,{
                    pauseOnFocusLoss: false,                    
                    toastId: `nvo-afil${1}`
                })          
                //getDatos( )   
                if (auxReg.length !==0 ) {
                    const posicion = listRutas.findIndex((element) => element.Id === auxReg.Id)
                    const arrMod={...auxReg, Alias:Alias, Descr:Descr, TpId:Tipo, 
                        ObjId: Objeto, DtId:Distrito, OtbId:OtbId, FIni:`${fechaIni}T00:00:00`,
                        FFin:`${fechaFin}T23:59:59`
                    }
                    listRutas.splice(posicion, 1, arrMod)
                    let nvoArr=listRutas
                    setListRutas(nvoArr)
                }  
                

                setModalAbierto(false);
                setNvoRegistro(aux)
                serCambioEfectivo(true) 
            }
        }
        llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setEspera,history,source);
    };

    const onChangeCorreo = e =>
	{   let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$@#_&-+()/.;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) &&
            !expMas.test(e.target.value) ) || e.target.value===' '|| e.target.value==='') 
        { 
            setRegistro({
                    ...registro, 
                    [e.target.name] : e.target.value  
                })
            if (aviso) 
            {   setMensaje('');
                setAviso(false);
            }
        }		
	};    

    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;                  
        if( campo===null || (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;                                   
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }     

    const mandaAlerta=(mensaje,tipoAdvert)=>
    {
        setMensaje(mensaje);
        setTipoAdvertencia(tipoAdvert)  
        setAviso(true);      
    }
      
    function validaVariable(auxCampo,auxMensaje,auxTamanio) 
    {   let respuesta=false
        if ( !verificaNulos(auxCampo,auxMensaje) ) 
        {   if (auxCampo.length>=auxTamanio ) 
            {                
                respuesta=true                    
            }else
            {            
                mandaAlerta('Campo '+auxMensaje +' incompleto, debe escribir un '+ auxMensaje+' valido',"warning") 
            }
        }   
          
        return respuesta;
    }
 
    function guardarDatos(e)
    {   e.preventDefault()                
        //serCambioEfectivo(true)          
        if (!verificaNulos(Distrito,"Distrito") 
            && !verificaNulos(Tipo,"Tipo") 
            && !verificaNulos(Objeto,"Tipo de Linea") 
            && validaVariable(Alias,'Alias',3)             
            && validaVariable(Descr,'Descripción',3) 
          )
        {           
            setMensaje('');                
            setAviso(false);                
                  
            llamadaNvoPerfil( )                               
        }                                  
    } 

    const onChangeDto=(e)=>{    
        if (e!== null && e!== undefined) 
        {   
            setRegistro({
                ...registro,
                Distrito :e.target.value,
                OtbId:""
            })      
            setMensaje('');                
            setAviso(false); 
        }else
        {   setRegistro({
                ...registro,
                Distrito : "",
                OtbId:""
            })           
        }       
   
    }  

    const onChangeSel=(e)=>{
        if (e!== null && e!== undefined) 
        {  setRegistro({...registro,[e.target.name] : e.target.value})
        }else
        {setRegistro({...registro,[e.target.name] : 0})
        } 
        
    }

    const DatosGenerales=(
        <div>            
           <Box   pt={1} mb={1} display="flex" flexDirection={"row"}>
             
                { listDistrito.length!==0 ?                
                <Box display={"flex"} mb={1}>
                <FormControl size='small'  style={{ minWidth:14+'rem'}} >
                    <InputLabel size='small' variant="outlined" id="Distrito-label-nvo">Distrito</InputLabel>
                    <Select  size='small' variant="outlined"    
                        label="Distrito" id="Distrito-select2" name="Distrito"
                        value={Distrito} onChange={onChangeDto}
                    >
                        {listDistrito.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{secc.cadena }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                    </FormControl>
                    </Box>
                :   null
                }    
            </Box>    
              {/*  listOtb.length!==0 ?                
                <Box display={"flex"} mb={2}>
                <FormControl size='small'  style={{ minWidth:14+'rem', }} >
                    <InputLabel size='small' variant="outlined" id="Otb-label-nvo">OTB</InputLabel>
                    <Select  size='small' variant="outlined"  
                        label="OTB" id="Otb-select2" name="OtbId"
                        value={OtbId} onChange={onChangeSel}
                    >
                        {listOtb.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{`${secc.Numero} - ${secc.Nom}` }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                    </FormControl>
                    </Box>
                :   null */
                }
            { listTipo.length!==0 ?                
                <Box display={"flex"} mb={2} mt={1} >
                <FormControl size='small'  style={{ minWidth:14+'rem'}} >
                    <InputLabel size='small' variant="outlined" id="tipo-label-nvo">Tipo</InputLabel>
                    <Select  size='small' variant="outlined"    
                        label="Tipo" id="tipo-select2" name="Tipo"
                        value={Tipo} onChange={onChangeSel}
                    >
                        {listTipo.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{secc.Nom }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                </FormControl>
                </Box>
            :   null
            }
            { listObjeto.length!==0 ?                
                <Box display={"flex"} mb={2} mt={1} >
                <FormControl size='small'  style={{ minWidth:14+'rem'}} >
                    <InputLabel size='small' variant="outlined" id="tipo-linea-label-nvo">Tipo de Linea</InputLabel>
                    <Select  size='small' variant="outlined"    
                        label="Tipo de Linea" id="tipo-select2" name="Objeto"
                        value={Objeto} onChange={onChangeSel}
                    >
                        {listObjeto.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{secc.Nom }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                </FormControl>
                </Box>
            :   null
            }

            <Relojes
                fechasSeleccionadas={fechasSeleccionadas}
                setFechasSeleccionadas={setFechasSeleccionadas}
            />
            
            <Box width={"20rem"} mt={1} ml={1}>
                <TextField required id="Alias-input" onChange={onChange} style={{paddingBottom:.5+'rem', marginRight:".5rem"}}
                    label="Alias" value={Alias} name='Alias'size="small" autoComplete='off' fullWidth                 
                />        
            </Box>
            <Box mt={1} ml={1}>
                <TextField  id="Descr-input" onChange={onChangeCorreo} style={{paddingBottom:1+'rem',}}
                    label="Descripción"  value={Descr} name='Descr' size="small" autoComplete='off' fullWidth    
                />  
            </Box>                           
        </div> 
    )     

    const cerrarBorrar = () => {            
        setAviso(false);
        setModalAbierto(false);
        if (cambioEfectivo) 
        {   
        
        }
    };

    return (    
    <Modal
        titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} btnDeshabilitado={btnDeshabilitado}
        setAviso={setAviso} tamanio={'md'} cargando={espera}     
        cerrarBorrar={cerrarBorrar}   
    >
        {DatosGenerales}
    </Modal>             
    )
}

export default ModalNvoEdit